import React, { useEffect, useState } from "react"

import {
    Card,
    CardBody,
    Col,
    Row,
    CardTitle,
    FormGroup,
    Form,
    Label,
    Button
} from "reactstrap"
import ScormUpload from "./components/ScormUpload";
import { setBreadcrumbItems } from "store/actions";
import { connect } from "react-redux";


const CreateScormCourse = (props) => {
    document.title = "Content Management | Create Scorm Course";



    const breadcrumbItems = [
        { title: "Course", link: "#" },
        { title: "Create Scorm Course", link: "#" },
    ]

    useEffect(() => {
        props.setBreadcrumbItems('Create Scorm Course', breadcrumbItems)
    })





    useEffect(() => {
        /* For closing the sidebar if opened */
        const blurDiv = document.getElementById("blur");
        var width = window.innerWidth;
        if (width <= 994) {
            blurDiv.click()
        }
    }, []);









    return (
        <React.Fragment>
            <Row>
                <Col>
                    <Card>

                        <CardBody className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            <div className=""></div>
                            <ScormUpload />
                        </CardBody>


                    </Card>
                </Col>
            </Row>




        </React.Fragment>
    )
}

export default connect(null, { setBreadcrumbItems })(CreateScormCourse);